<template>
  <div class="product-popup">
    <i class="material-icons close_icon" @click="closePopUp()">close</i>
    <div class="product-details product_detail_page">
      <div class="top-block" v-if="allDetails">
        <span class="product-img" v-if="allDetails.itemMediaDTOList">
          <img :src="allDetails.itemMediaDTOList[0].thumbnail" alt />
        </span>
        <div class="product-title">
          <h4>{{allDetails.productName}}</h4>
          <span>₹​{{allDetails.sellingPrice}}</span>
          <strike>₹​{{allDetails.mrp}}</strike>
        </div>
        <span
          class="ext-discount"
          v-if="allDetails.onlineDiscount > 0 && isShowSnackbar"
        >{{$t('onlineDiscountOnProd',{cost:allDetails.onlineDiscount})}}</span>
      </div>

      <div
        class="detail_section"
        v-if="allDetails.selectableAttributes!= null && (allDetails.selectableAttributes.SIZE || allDetails.selectableAttributes.COLOR)"
      >
        <Color
          @saleReferenceID="saleReference_id"
          @ProductColor="ItemColor"
          @ProductSize="ItemSize"
          @Stock="StockData"
          :dataColor="allDetails"
        />
      </div>
      <div class="detail_section">
        <AboutProduct :dataAbtPrd="allDetails" />
      </div>

      <div class="detail_section share_section">
        <ShareAndEarn :dataShareAndEarn="allDetails" v-if="!allDetails.cutPriceEnable" />
      </div>
      <div class="detail_section">
        <ProductPolicy :productPolicy="allDetails" />
      </div>
      <div class="detail_section">
        <h6 class="prdt_sub_hdng">
          {{$t('seller')}} -
          <span>{{allDetails.sellerName}}</span>
        </h6>
      </div>
    </div>
    <div class="order_button" v-if="allDetails.inStock && allDetails.groupDiscount">
      <span
        class="tabIcon"
        :class="{'active' : isBookMark == false}"
        @click="bookMark(allDetails.saleReferenceID,isBookMark)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 14 17">
          <path
            fill="#505050"
            fill-rule="evenodd"
            d="M11.433 14.328V2.52a.829.829 0 0 0-.816-.84H2.45a.829.829 0 0 0-.817.84v11.808l4.426-3.252a.798.798 0 0 1 .949 0l4.425 3.252zm-4.9-1.536l-5.242 3.852c-.54.397-1.291 0-1.291-.684V2.52C0 1.128 1.097 0 2.45 0h8.167c1.353 0 2.45 1.128 2.45 2.52v13.44c0 .683-.751 1.08-1.292.684l-5.242-3.852z"
          />
        </svg>
      </span>
      <button type="button" class="large_green_btn single" @click="viaPaytmCashCall(true)">
        {{$t('buyNow')}}
        <br />
        <span>{{$t('priceForsingleBuy', {singlePrice:allDetails.finalPaidAmount})}}</span>
      </button>
      <router-link
        :to="'/group-list/?productId='+ allDetails.productId + '&itemId=' + allDetails.saleReferenceID"
        tag="button"
        type="button"
        class="large_green_btn group"
      >
        {{$t('groupBuy')}}
        <br />
        <span
          v-if="Math.trunc(allDetails.finalPaidAmount - allDetails.groupDiscount) < 0"
        >{{$t('priceForGroupBuy' , {groupPrice:0})}}</span>
        <span
          v-else
        >{{$t('priceForGroupBuy' , {groupPrice:Math.trunc(allDetails.finalPaidAmount - allDetails.groupDiscount)})}}</span>
      </router-link>
    </div>
    <div class="order_button" v-if="allDetails.inStock && !allDetails.groupDiscount">
      <span
        class="tabIcon"
        :class="{'active' : isBookMark == false}"
        @click="bookMark(allDetails.saleReferenceID,isBookMark)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17">
          <path
            fill="#505050"
            fill-rule="evenodd"
            d="M11.433 14.328V2.52a.829.829 0 0 0-.816-.84H2.45a.829.829 0 0 0-.817.84v11.808l4.426-3.252a.798.798 0 0 1 .949 0l4.425 3.252zm-4.9-1.536l-5.242 3.852c-.54.397-1.291 0-1.291-.684V2.52C0 1.128 1.097 0 2.45 0h8.167c1.353 0 2.45 1.128 2.45 2.52v13.44c0 .683-.751 1.08-1.292.684l-5.242-3.852z"
          />
        </svg>
      </span>
      <button type="button" class="large_green_btn" @click="viaPaytmCashCall(true)">{{$t('buyNow')}}</button>
    </div>
    <div class="order_button" v-if="allDetails.inStock == false">
      <button
        type="button"
        class="large_green_btn order_on_chat"
        @click="viaPaytmCashCall(true)"
      >{{$t('outOfStock')}}</button>
    </div>
  </div>
</template>
    <script>
import Swiper from "swiper";
import "../../assets/css/swiper-slider.css";
import CutThePrice from "../ProductDetailSection/ProductDetailTab/CutThePrice";
import PrdtName from "../ProductDetailSection/ProductDetailTab/PrdtName";
import Color from "../ProductDetailSection/ProductDetailTab/Color";
import AboutProduct from "../ProductDetailSection/ProductDetailTab/AboutProduct";
import ShareAndEarn from "../ProductDetailSection/ProductDetailTab/ShareAndEarn";
import ProductPolicy from "../ProductDetailSection/ProductDetailTab/ProductPolicy";
import { bus } from "../../main";
export default {
  name: "LiveShopPopUp",
  components: {
    CutThePrice,
    PrdtName,
    Color,
    AboutProduct,
    ShareAndEarn,
    ProductPolicy
  },
  props: {
    dataValue: {
      required: true,
      type: Object
    },
    dataStyleAmount: {
      type: Boolean
    },
    popUpData: {
      type: Boolean
    }
  },
  data() {
    return {
      saleReferenceID: null,
      loading: false,
      categoryId: 0,
      pageIndex: 0,
      allDetails: {},
      colorDetails: {},
      sizeDetails: [],
      buttonMsg: "27%",
      color: null,
      size: null,
      xauthid: this.$cookie.get("X-Auth-Id"),
      recommendedProductList: [],
      displayTimeText: "",
      isShowSnackbar: false,
      ApiType: "createPreOrderAgain",
      isBookMark: true,
    };
  },
  watch: {
    dataValue() {
      var _this = this;
      this.allDetails = this.dataValue;
      if (this.allDetails) {
        if (this.allDetails.dealDisplayMessage) {
          this.isShowSnackbar = false;
        } else {
          this.isShowSnackbar = true;
        }
        this.$cookie.set("ProductId", this.allDetails.productId);
        this.buttonMsg = `${this.allDetails.onlineDiscount} ₹​ अतिरिक्त छूट`;
      }
    }
  },
  methods: {
    closePopUp() {
      this.$emit("closePopUp");
    },
    bookMark(productId, isBookMark) {
      var xauthid = this.$cookie.get("X-Auth-Id");
      try {
        if (this.isBookMark) {
          this.isBookMark = false;
        } else {
          this.isBookMark = true;
        }
        JSBridgePlugin.bookmarkProduct(Number(productId), isBookMark);
      } catch (err) {
        console.log(err);
      }
    },
    getLiveTime(value) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    timerStop(obj) {
      if (this.liveData.length > 0) {
        this.liveData[obj.index].status = false;
      }
    },
    applycutprice(cuttheprice_boolean) {
      this.$emit("ENABLACUTPRICE", cuttheprice_boolean);
    },
    StockData(obj) {
      this.allDetails.inStock = obj.stock;
      this.allDetails.finalPaidAmount = obj.finalPaidAmount;
      this.allDetails.mrp = obj.mrp;
    },
    ItemColor(color) {
      this.color = color;
      console.log(this.color)
    },
    saleReference_id(value) {
      this.saleReferenceID = value;
      console.log(value)
    },
    ItemSize(size) {
      this.size = size;
    },
    CheckFields(online) {
      if (
        this.allDetails.selectableAttributes != null &&
        this.allDetails.selectableAttributes.COLOR &&
        this.allDetails.selectableAttributes.COLOR.length > 0
      ) {
        if (this.color) {
          this.checkSize();
        } else {
          let obj = {
            status: this.$t("selectColor"),
            color: "black",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        }
      } else {
        this.checkSize();
      }
    },
    checkSize() {
      if (
        this.allDetails.selectableAttributes != null &&
        this.allDetails.selectableAttributes.SIZE &&
        this.allDetails.selectableAttributes.SIZE.length > 0
      ) {
        if (this.size) {
          this.viaPaytmCashCall(true);
        } else {
          let obj = {
            status: this.$t("selectSize"),
            color: "black",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        }
      } else {
        this.viaPaytmCashCall(true);
      }
    },
    viaPaytmCashCall(online) {
      this.loading = true;
      const obj = {
        saleReferenceID:
          this.saleReferenceID || this.$route.params.saleReferenceID,
        referralUserId: this.allDetails.encodedId,
        size: this.size,
        color: this.color,
        preOrderSource: "ONLINE_FORM"
      };
      console.log(obj);
      if (this.$cookie.get("version-code") > 58) {
        this.ApiType = "createPreOrderAgain";
      } else {
        this.ApiType = "createPreOrder";
      }
      this.$store
        .dispatch({
          type: this.ApiType,
          payload: obj
        })
        .then(data => {
          this.loading = false;
          clevertap.event.push("PRODUCT_BUY_WHATSAPP", {
            ProductName: null,
            saleReferenceID:
              this.saleReferenceID || this.$route.params.saleReferenceID,
            Price: null
          });

          clevertap.event.push("PRODUCT_BUY_ONLINE", {
            ProductName: null,
            saleReferenceID:
              this.saleReferenceID || this.$route.params.saleReferenceID,
            Price: null
          });
          clevertap.event.push("ECOM_CREATE_PRE_ORDER", {
            ProductName: null,
            saleReferenceID:
              this.saleReferenceID || this.$route.params.saleReferenceID
          });
          if (online) {
            if (this.$route.query.source) {
              this.$router.onError(err => {
                if (/loading chunk \d* failed./i.test(err.message)) {
                  window.location.reload();
                }
              });
              this.$router.push(
                "/preOrderDetails/" +
                  data.data.preOrderId +
                  "?source=" +
                  this.$route.query.source
              );
            } else {
              this.$router.onError(err => {
                if (/loading chunk \d* failed./i.test(err.message)) {
                  window.location.reload();
                }
              });
              this.$router.push(
                "/preOrderDetails/" +
                  data.data.preOrderId +
                  "?source=MALL91_LIVE"
              );
            }
          } else {
            window.location.href = data.data.orderOnWhatsapp;
          }
        })
        .catch(err => {
          if (err.response.data.message == "PRODUCT_IS_OUT_OF_STOCK") {
            this.loading = false;
            this.emitToaster("ItemOutStock");
          } else if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = res => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.ApiType = "createPreOrderAgain";
                  this.viaPaytmCashCall(true);
                } else {
                  this.loading = false;
                  this.emitToaster("Something went wrong! Try Again Later");
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          } else {
            this.loading = false;
            this.emitToaster("Failure");
          }
        });
    },
    emitToaster(status) {
      let obj = {
        status: status,
        timeoutMs: "5000"
      };
      bus.$emit("apiStatus", obj);
    }
  },
  mounted() {
    if (this.dataValue) {
      this.allDetails = this.dataValue;
      this.saleReferenceID = this.allDetails.saleReferenceID;
      if (this.allDetails) {
        if (this.allDetails.dealDisplayMessage) {
          this.isShowSnackbar = false;
        } else {
          this.isShowSnackbar = true;
        }
        this.buttonMsg = `${this.allDetails.onlineDiscount} ₹​ अतिरिक्त छूट`;
      }
    }
  }
};
</script>